import { Module } from 'vuex';
import { ProductsState, RootState } from '@/types';
import mutations from './mutations';
import actions from './actions';
import getters from './getters';
import { emptyProductsState } from "@/store/modules/products/stateFactory";


const state: ProductsState = emptyProductsState();

const products: Module<ProductsState, RootState> = {
  state,
  mutations,
  actions,
  getters,
};

export default products;



// WEBPACK FOOTER //
// ./src/store/modules/products/index.ts